import { CALL_API } from 'redux-api-middleware';
import * as fromRootReducer from '../../modules/root-reducer';
import { ACCESS_COMPLETE, LOGOUT, REFRESH } from '../../modules/auth';

// Adds data from the store to the body of accessComplete and logout API requests
// Insert before redux-api-middleware in chain
export const middleware = ({
  getAccessStartToken, getAccessToken, getRefreshToken,
}) => store => next => action => {
  const callAPI = action[CALL_API];

  if (!callAPI || !callAPI.options || !callAPI.options.authStage) {
    return next(action);
  }

  if (callAPI.options.authStage === ACCESS_COMPLETE) {
    const currentBody = JSON.parse(callAPI.body || '{}');
    callAPI.body = JSON.stringify({
      ...currentBody,
      token: getAccessStartToken(store.getState()),
    });
  }

  if (callAPI.options.authStage === LOGOUT) {
    const currentBody = JSON.parse(callAPI.body || '{}');
    callAPI.body = JSON.stringify({
      ...currentBody,
      accessToken: getAccessToken(store.getState()),
    });
  }

  if (callAPI.options.authStage === REFRESH) {
    const currentBody = JSON.parse(callAPI.body || '{}');
    callAPI.body = JSON.stringify({
      ...currentBody,
      refreshToken: getRefreshToken(store.getState()),
    });
  }

  return next(action);
};

export default middleware({
  getAccessToken: fromRootReducer.getAccessToken,
  getAccessStartToken: fromRootReducer.getAccessStartToken,
  getRefreshToken: fromRootReducer.getRefreshToken,
});
